import { toggleSidebar } from "../../utils/sidebarToggle";

export default function PageHeader({ type }) {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3">
        {type === "Gold" ? "Gold Rate Work" : "Silver Rate Work"}
      </div>

      <div className="headIcons d-flex me-3">
        <div className="iconMain">
          <i className="fa-solid fa-search" />
        </div>

        <div className="iconMain ms-3 me-3">
          <i className="fa-solid fa-exclamation" />
        </div>

        <div className="iconMain" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars" />
        </div>
      </div>
    </div>
  );
}
